export enum UserRole {
  ADMIN = 1,
  EMPLOYEE
}

export enum MRIType {
  Brain = 1,
  ThoracicSpine,
  LShoulder,
  LElbow,
  LWrist_Hand,
  LHip,
  LKnee,
  LAnkle_Foot,
  RShoulder,
  RElbow,
  RWrist_Hand,
  RHip,
  RKnee,
  RAnkle_Foot
}

export enum EDT {
  UpperSSEP = 1,
  LowerSSEP,
  BAER,
  VER,
  EEG,
  UpperCPT,
  LowerCPT
}

export enum CaseType {
  NoFault = 1,
  NoFault_Other,
  WorkersComp,
  WorkersComp_Other,
  Line,
  SelfPay,
  MajorMed_HMO,
  Medicare,
  NoFault_Youth,
  NoFault_Denied,
  OrthoOnly
}

export enum Page {
  Size = 15
}

export enum ToastType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = ''
}

export enum MaxLength {
  Phone = 18,
  Zip = 5,
  OTP = 6
}

export enum PatientCallingEnum {
  'Confirmed' = 1,
  'No Answer',
  'Left Message',
  'Not Coming',
  'Resheduled'
}

export enum AppointmentFilter {
  'All' = 1,
  'MD',
  'MRI',
  'Neuro',
  'Ortho',
  'Pain'
}
